/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { breakpoints, typography2 } from '@coursera/cds-core';

import Section from 'bundles/front-page/components/Section';
import InlineLearningGoalQuestion from 'bundles/onboarding-common/components/InlineLearningGoalQuestion';

const styles = {
  onboarding: css`
    background-color: var(--cds-color-emphasis-primary-background-xweak);
    border: none;

    h2 {
      ${breakpoints.down('xs')} {
        ${typography2.subtitleMedium};
      }
    }
  `,
};

const OnboardingModuleRenderer = () => {
  return (
    <Section>
      <InlineLearningGoalQuestion css={styles.onboarding} />
    </Section>
  );
};

export default OnboardingModuleRenderer;
